//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import seo from '~/mixins/seo'
import webinarQuery from '~/apollo/queries/webinars/webinar-slug'

export default {
  mixins: [seo],
  data () {
    return {
      fetched: false
    }
  },
  apollo: {
    webinars: {
      prefetch: true,
      query: webinarQuery,
      variables () {
        return { slug: this.$route.params.slug }
      },
      // `data` is undefined when the query errored — guard or the SSR process dies.
      result ({ data, loading, networkStatus }) {
        if (data && data.webinars && data.webinars.length > 0) {
          this.seoTitle = data.webinars[0].title
        }
        this.fetched = true
      },
      error (error) {
        console.error('[apollo] ' + this.$route.fullPath + ': ' + (error && error.message))
        this.fetched = true
      }
    }
  }
}

